import { defineStore } from "pinia";
import { games } from "~/configurations/games.config";
const mmoGames = ["world-of-warcraft-boost"];

export const useGameStore = defineStore("game", {
  state: () => ({
    game: {
      packs: [],
    },
    gamepack: {
      pack_options: [],
      title: "",
      description: "",
      pack_extra_options: [],
    },
    boosters: [],
    cachedPacks: [],
    gameranks: [],
    gameheros: [],
    gamepacksloading: true,
    categories: [],
    prevLocale: "en",
    cachedPacks: [],
  }),
  getters: {
    getGame: (state) => state.game,
    getGamePacks: (state) => state.game?.packs || [],
    getGameBoosters: (state) => state.boosters,
    getGamePack: (state) => state.gamepack,
    getGameRanks: (state) => state.gameranks,
    getGameHeroes: (state) => state?.gameheros || [],
    getGameLoading: (state) => state.gamepacksloading,
  },

  actions: {
    resetGame() {
      this.$patch({
        game: {
          packs: [],
          faqs: [],
        },
        gameranks: [],
        gameheros: [],
      });
    },
    setGameLoading(payload) {
      this.$state.gamepacksloading = payload;
    },
    resetHeroes() {
      this.$patch({
        gameheros: [],
      });
    },

    setGame(payload) {
      this.$patch({
        game: {
          ...payload,
          gameheros: [],
          faqs: payload?.faqs || [],
        },
      });
    },
    setGamePack(payload) {
      this.$patch({
        gamepack: {},
      });
      this.$patch({
        gamepack: {
          ...payload,
          pack_slots: payload?.pack_slots ? payload.pack_slots : null,
        },
      });
    },
    setHeroes(payload) {
      this.$patch({ gameheros: payload });
    },
    setRanks(payload) {
      this.$patch({ gameranks: payload });
    },
    async apiGetGame(payload) {
      try {
        const gameSlug = payload.gameSlug;
        if (
          this.$state.game?.slug === gameSlug &&
          this.$state.prevLocale === payload.locale
        ) {
          return;
        }
        this.$patch({
          prevLocale: payload.locale,
        });

        this.setGameLoading(true);

        let path = "get-game";
        if (mmoGames.includes(gameSlug)) {
          path = "get-mmo-game";
        }
        const { data: response, error } = await useApiFetch(
          `/api/${path}/${gameSlug}`,
          {
            method: "post",
            fetchKey: `api-get-game`,
            body: {
              locale: payload?.locale || "en",
              params: ["servers", "platforms", "roles", "faqs", "game_season"],
              gameSlug: gameSlug,
            },
            initialCache: false,
          }
        );
        if (response.value?.data) {
          this.setGame(response.value?.data);
          this.setGameLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async apiGetGameRanks(payload) {
      try {
        const gameSlug = payload.gameSlug;
        if (
          this.$state.game?.slug === gameSlug &&
          this.$state.prevLocale === payload.locale &&
          this.$state.gameranks?.length > 0
        ) {
          return;
        }
        let rankPath = "get-game-ranks";
        if (mmoGames.includes(gameSlug)) {
          rankPath = "get-mmo-game-ranks";
        }
        const { data: response, error } = await useApiFetch(
          `/api/${rankPath}/${gameSlug}`,
          {
            fetchKey: `/api/${rankPath}}/${gameSlug}`,
            method: "GET",
          }
        );
        if (response.value?.data) {
          this.$patch({ gameranks: response.value?.data });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async apiGetGameHeroes(payload) {
      try {
        const gameSlug = payload.gameSlug;
        if (gameSlug === "world-of-warcraft-boost") {
          return;
        }
        if (
          this.$state.game?.slug === gameSlug &&
          this.$state.gameheros?.length > 0
        ) {
          return;
        }
        const { data: response, error } = await useApiFetch(
          `/api/get-game-heroes/${gameSlug}`,
          {
            fetchKey: `/api/get-game-heroes/${gameSlug}`,
            method: "GET",
          }
        );
        if (response.value) {
          this.$patch({ gameheros: response.value });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async apiGetMmoGameHeroes(payload) {
      try {
        const gameSlug = payload.gameSlug;
        if (
          this.$state.game?.slug === gameSlug &&
          this.$state.gameheros?.length > 0
        ) {
          return;
        }

        const { data: response, error } = await useApiFetch(
          `/api/get-mmo-game-heroes/${gameSlug}`,
          {
            fetchKey: `/api/get-mmo-game-heroes/${gameSlug}`,
            method: "GET",
          }
        );
        if (response.value) {
          this.$patch({ gameheros: response.value });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
});
